export const FETCH_STATUS_SUMMARY_PENDING = 'FETCH_STATUS_SUMMARY_PENDING'
export const FETCH_STATUS_SUMMARY_FULFILLED = 'FETCH_STATUS_SUMMARY_FULFILLED'
export const FETCH_STATUS_SUMMARY_REJECTED = 'FETCH_STATUS_SUMMARY_REJECTED'

export const UPDATE_STATUS_SUMMARY = 'UPDATE_STATUS_SUMMARY'
